import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateInputFillMode, DateInputRounded } from '@progress/kendo-angular-dateinputs';
import { isEqual } from 'lodash';

@Component({
  selector: 'admin-users-list-filter',
  templateUrl: './admin-users-list-filter.component.html',
  styleUrls: ['./admin-users-list-filter.component.scss'],
  standalone: false,
})
export class AdminUsersListFilterComponent implements OnInit {
  public constructor(private _activeModal: NgbActiveModal) {}

  public pageFilter: app.models.GetAdminUsersPageFilterModel;
  public initialFilterState: app.models.GetAdminUsersPageFilterModel;
  public fillModeOutline: DateInputFillMode = 'outline';
  public roundedLarge: DateInputRounded = 'large';
  public startDate: Date;
  public endDate: Date;

  ngOnInit(): void {
    if (this.pageFilter.startDate) {
      this.startDate = new Date(this.pageFilter.startDate);
    }

    if (this.pageFilter.endDate) {
      this.endDate = new Date(this.pageFilter.endDate);
    }
  }

  public closeHandler(status: boolean) {
    this._activeModal.close(status);
  }

  public resetHandler() {
    this.pageFilter.startDate = null;
    this.pageFilter.endDate = null;

    this._activeModal.close(isEqual(this.pageFilter, this.initialFilterState) ? false : 0);
  }

  public applyHandler() {
    if (this.startDate) this.pageFilter.startDate = this.startDate;
    if (this.endDate) this.pageFilter.endDate = this.endDate;

    let filterCount = 0;
    if (this.pageFilter.startDate != null) filterCount++;
    if (this.pageFilter.endDate != null) filterCount++;

    this._activeModal.close(isEqual(this.pageFilter, this.initialFilterState) ? false : filterCount);
  }

  disabledPastDates = (date: Date) => {
    return date < this.startDate;
  };

  startDateChangeHandler() {
    if (this.endDate < this.startDate) this.endDate = undefined;
  }
}
